/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/logger/CustomLogger.ts
 * @create:      2025-06-20 17:13:53.268
 * @modify:      2025-10-14 22:39:26.171
 * @version:     6.1.0
 * @times:       17
 * @lines:       65
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

import { ILogOptions } from "../interface/ILogOptions";
import { ILoggingAgent } from "../interface/ILoggingAgent";

/**
 * @since 5.0.0
 * @version 2025-06-20
 */
export class CustomLogger implements ILoggingAgent {
    private readonly logger: ILoggingAgent;

    public readonly Options: ILogOptions;

    public constructor(options: ILogOptions, logger: ILoggingAgent) {
        this.Options = options;
        this.logger = logger;
    }

    public Info(data: unknown, options?: ILogOptions): void {
        options = Object.assign(options ?? {}, this.Options);
        this.logger.Info(data, options);
    }

    public Warn(data: unknown, options?: ILogOptions): void {
        options = Object.assign(options ?? {}, this.Options);
        this.logger.Warn(data, options);
    }

    public Error(data: unknown, options?: ILogOptions): void {
        options = Object.assign(options ?? {}, this.Options);
        this.logger.Error(data, options);
    }
}
